import React from "react";
import * as S from "./Styles";

interface MenuButtonProps {
  isOpen?: boolean;
  toggleMenu?: () => void;
}

const MenuButton = ({ isOpen, toggleMenu }: MenuButtonProps) => {
  return (
    <S.Button onClick={toggleMenu} aria-label="Meny knapp">
      <S.Line
        $isOpen={isOpen}
        style={{
          transform: isOpen ? "rotate(-45deg) translate(-5px, 6px)" : "none",
          opacity: 1,
          borderRadius: "15px",
        }}
      />
      <S.Line $isOpen={isOpen} style={{ opacity: isOpen ? 0 : 1, borderRadius: "15px" }} />
      <S.Line
        $isOpen={isOpen}
        style={{
          transform: isOpen ? "rotate(45deg) translate(-5px, -6px)" : "none",
          opacity: 1,
          borderRadius: "15px",
        }}
      />
    </S.Button>
  );
};

export default MenuButton;
